export var dividerContainer = 'relative h-2.5';
export var dividerWrapper = 'absolute inset-0 flex items-center';
export var divider = 'w-full border-t border-uiLight';
export var titleContainer = 'relative flex justify-center';
export var title = 'px-2 bg-white text-sm text-textMid leading-3';
//# sourceMappingURL=divider.styles.js.map